import React, { useState } from "react";
import styles from "./selectFieldComponent.module.scss";

const SelectFieldComponent = ({
  optionsList,
  firstOption,
  value, // Ensure the value is received
  onChange,
  className,
}) => {
  return (
    <div className={className}>
      <select
        className={`${styles.select} ${className}`}
        onChange={onChange} // Controlled component
        value={value || ""} // Ensure it gets controlled value
      >
        <option value="" disabled hidden>
          {firstOption}
        </option>
        {optionsList.map((dt, index) => (
          <option value={dt?.value} key={index}>
            {dt?.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectFieldComponent;
